export default __webpack_public_path__ + "d57db61bf9e074c6e7b201d8ea131b3b.png";